module.exports = __webpack_public_path__ + "static/half_orc_male_barbarian_totem-15c1c69e5d7dc2ec3bf25b3b83dc305e.png";